<template>
  <div class="edit-tag-dialog">
    <p>Tag points on the graph to provide feedback fro AI training.</p>
    <el-form label-width="100px">
      <el-form-item label="Tag Type">
        <el-select v-model="tagType" placeholder="Select tag type" class="w-full">
          <el-option label="Type A" value="A"></el-option>
          <el-option label="Type B" value="B"></el-option>
          <el-option label="Type C" value="C"></el-option>
      </el-select>
      </el-form-item>
      <el-form-item label="Time">
        <el-date-picker v-model="tagTime" type="datetime" placeholder="Pick a time" style="width:100%;"/>
      </el-form-item>
      <el-form-item label="Note">
        <el-input type="textarea" v-model="tagNote" placeholder="Enter note" :rows="3" class="w-full"/>
      </el-form-item>
    </el-form>
    <div class="flex flex-row justify-end">
      <el-button type="primary" @click="handleConfirm">Confirm</el-button>
      <el-button type="default" @click="handleCancel">Cancel</el-button>
    </div>
  </div>
</template>

<script>
export default {
  emits: ['confirm', 'cancel'],
  data() {
    return {
      tagType: '',
      tagTime: '',
      tagNote: ''
    };
  },
  methods: {
    handleConfirm() {
      this.$emit('confirm', {
        type: this.tagType,
        time: this.tagTime,
        note: this.tagNote
      });
    },
    handleCancel() {
      this.$emit('cancel');
    }
  }
}
</script>
<style scoped>
.edit-tag-dialog {
  flex: 1;
  display: flex;
  flex-direction: column;
}
</style>
